import React from 'react'
import { useState } from 'react';




const CmpFilterList = (props) => {
    const { value, filters , onChangeValue } = props;
    const [selected, setSelected] =  useState(value || {key: '', label: 'None'});

    function handleClick(val, e) {            
      setSelected(val)
      onChangeValue(val)        
      e.preventDefault();
    }        
    
    return(
        <div>
            <ul>
                {filters.map((item) => {
                return <li key={`${item.key}`} className={`entidad ${item.key==selected.key ? "selected" : ""}`}>
                  <i className="icon bx-map"></i>
                  <a href="#!"  onClick={(e) => handleClick(item, e)}>{item.label}</a>
                  </li>
                })}
            </ul>
        </div>
    )

}

export default CmpFilterList